import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: 'save-versions.dialog.html',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'aca-save-versions-dialog' },
  standalone: false,
})
export class SaveVersionsComponent {
  sectionType = 1;
  isDocument: string;

  constructor(
    public dialogRef: MatDialogRef<SaveVersionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isDocument = data.isFile === true ? 'Document' : 'Folder';
  }

  save(): void {
    const majority = this.sectionType === 1 ? 'minor' : 'major';
    const data = {
      version: majority,
      comment: this.data.comment,
    };
    this.dialogRef.close(data);
  }

  close(): void {
    this.dialogRef.close();
  }
}
